// extracted by mini-css-extract-plugin
export default {"box":"table-row-actions_box__iVnUS"};